import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "space-y-5"
};
const _hoisted_2 = ["aria-label", "aria-checked", "disabled", "onMouseenter", "onClick"];
const _hoisted_3 = {
  class: "ml-3 rounded-md bg-slate-100 px-2.5 py-1 text-sm font-medium text-slate-700"
};
const _hoisted_4 = {
  class: "block"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  key: 0,
  class: "block"
};
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
  class: "flex justify-end"
};
const _hoisted_9 = ["disabled"];
import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { StarIcon } from '@heroicons/vue/24/solid';
export default {
  __name: 'ReportEvaluationPanel',
  props: {
    report: {
      type: Object,
      default: () => ({})
    },
    submitting: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const gradeOptions = [{
      score: 1,
      grade: 'UNQUALIFIED'
    }, {
      score: 2,
      grade: 'NEEDS_IMPROVEMENT'
    }, {
      score: 3,
      grade: 'MEETS_EXPECTATIONS'
    }, {
      score: 4,
      grade: 'GOOD'
    }, {
      score: 5,
      grade: 'EXCELLENT'
    }];
    const score = ref(0);
    const hoveredScore = ref(0);
    const comment = ref('');
    const improvementSuggestion = ref('');
    const previewScore = computed(() => hoveredScore.value || score.value);
    const selectedGrade = computed(() => gradeOptions.find(option => option.score === score.value));
    const isLowScore = computed(() => score.value <= 2 && score.value > 0);
    watch(() => props.report, report => {
      const evaluation = currentEvaluationOf(report);
      score.value = gradeOptions.find(option => option.grade === evaluation.grade)?.score || 0;
      comment.value = evaluation.comment || '';
      improvementSuggestion.value = '';
    }, {
      immediate: true
    });
    function currentEvaluationOf(report) {
      const evaluations = Array.isArray(report?.evaluations) ? report.evaluations : [];
      return evaluations.find(evaluation => evaluation.current && evaluation.phase === 'SUMMARY') || {};
    }
    function submitEvaluation() {
      if (!score.value || !selectedGrade.value) {
        ElMessage.warning('请选择评分');
        return;
      }
      if (isLowScore.value && !improvementSuggestion.value.trim()) {
        ElMessage.warning('低分评价必须填写改进建议');
        return;
      }
      const normalizedComment = isLowScore.value ? [comment.value.trim(), `改进建议：${improvementSuggestion.value.trim()}`].filter(Boolean).join('\n') : comment.value.trim();
      emit('submit', {
        phase: 'SUMMARY',
        grade: selectedGrade.value.grade,
        comment: normalizedComment
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("div", null, [_createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "日报评价"), _createElementVNode("p", {
        class: "mt-1 text-sm text-slate-500"
      }, "评价用于反馈工作过程与结果，不会改变日报的提交状态。")], -1)), _createElementVNode("div", null, [_cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "form-label"
      }, [_createTextVNode("评分 "), _createElementVNode("span", {
        class: "text-red-500"
      }, "*")], -1)), _createElementVNode("div", {
        class: "mt-2 flex items-center gap-0.5",
        role: "radiogroup",
        "aria-label": "评分",
        onMouseleave: _cache[0] || (_cache[0] = $event => hoveredScore.value = 0)
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(gradeOptions, option => {
        return _createElementVNode("button", {
          key: option.grade,
          type: "button",
          class: _normalizeClass(["rounded-lg p-1 transition-all duration-150 hover:scale-110 focus:outline-none", option.score <= previewScore.value ? 'text-amber-400' : 'text-slate-200 hover:text-amber-300']),
          "aria-label": `${option.score} 星`,
          "aria-checked": option.score === score.value,
          disabled: __props.disabled,
          role: "radio",
          onMouseenter: $event => hoveredScore.value = option.score,
          onClick: $event => score.value = option.score
        }, [_createVNode(_unref(StarIcon), {
          class: "h-8 w-8",
          "aria-hidden": "true"
        })], 42, _hoisted_2);
      }), 64)), _createElementVNode("span", _hoisted_3, _toDisplayString(score.value ? `${score.value} / 5` : '未评分'), 1)], 32)]), _createElementVNode("label", _hoisted_4, [_cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "form-label"
      }, "评价意见", -1)), _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => comment.value = $event),
        class: "form-textarea mt-1 w-full",
        rows: "4",
        placeholder: "填写可执行的反馈",
        disabled: __props.disabled
      }, null, 8, _hoisted_5), [[_vModelText, comment.value]])]), isLowScore.value ? (_openBlock(), _createElementBlock("label", _hoisted_6, [_cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "form-label"
      }, [_createTextVNode("改进建议 "), _createElementVNode("span", {
        class: "text-red-500"
      }, "*")], -1)), _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => improvementSuggestion.value = $event),
        class: "form-textarea mt-1 w-full",
        rows: "4",
        placeholder: "低分评价必须填写改进建议",
        disabled: __props.disabled
      }, null, 8, _hoisted_7), [[_vModelText, improvementSuggestion.value]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
        type: "button",
        class: "btn-primary",
        disabled: __props.submitting || __props.disabled,
        onClick: submitEvaluation
      }, _toDisplayString(__props.submitting ? '提交中' : '提交评价'), 9, _hoisted_9)])]);
    };
  }
};